import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: (main:boolean,isEven:boolean, isParent:boolean) => ({ 
            width: "100%", 
            mx: "auto",
            minHeight: main ? '400px' : '200px',
            overflowY: 'auto',
        })
    }
}

export { useStyles }
